import React from 'react'

import PropTypes from 'prop-types'

import './contactscomponent.css'

const Contactscomponent = (props) => {
  return (
    <div className="contactscomponent-container thq-section-padding">
      <div className="contactscomponent-thq-max-width-elm">
        <h1 className="contactscomponent-title H1_large">Контакты</h1>
        <div className="contactscomponent-thq-content-elm1">
          <div className="contactscomponent-thq-content-elm2">
            <a
              href="mailto:info@arcobo.tech?subject="
              className="contactscomponent-link1"
            >
              <div className="contactscomponent-thq-content-elm3">
                <img
                  alt="Email"
                  loading="lazy"
                  src="/contact-icons/gmail-200h.webp"
                  className="contactscomponent-image1"
                />
                <div className="contactscomponent-thq-contact-info-elm1">
                  <h3 className="contactscomponent-thq-text-elm1 H1_large">
                    Email
                  </h3>
                  <span className="text_large">info@arcobo.tech</span>
                </div>
              </div>
            </a>
            <a href="tel:+7 747 13 747 13" className="contactscomponent-link2">
              <div className="contactscomponent-thq-content-elm4">
                <img
                  alt="Телефон"
                  loading="lazy"
                  src="/contact-icons/call-200h.webp"
                  className="contactscomponent-image2"
                />
                <div className="contactscomponent-thq-contact-info-elm2">
                  <h3 className="contactscomponent-thq-text-elm2 H1_large">
                    Телефон
                  </h3>
                  <span className="text_large">+7 747 13 747 13</span>
                </div>
              </div>
            </a>
            <a
              href="https://www.google.com/maps/search/?api=1&amp;query=Казахстан,+г.+Алматы,+ул.+Митина+4/1"
              target="_blank"
              rel="noreferrer noopener"
              className="contactscomponent-link3"
            >
              <div className="contactscomponent-thq-content-elm5">
                <img
                  alt="Адрес"
                  loading="lazy"
                  src="/contact-icons/location-200h.webp"
                  className="contactscomponent-image3"
                />
                <div className="contactscomponent-thq-contact-info-elm3">
                  <h3 className="contactscomponent-thq-text-elm4 H1_large">
                    Адрес
                  </h3>
                  <span className="text_large">
                    <span>Казахстан, г.  Алматы, ул. Митина 4/1</span>
                    <br></br>
                    <span>Время работы: с 9-00 до 19-00</span>
                    <br></br>
                  </span>
                </div>
              </div>
            </a>
            <a
              href="https://t.me/arcobo_robotics"
              target="_blank"
              rel="noreferrer noopener"
              className="contactscomponent-link4"
            >
              <div className="contactscomponent-thq-content-elm6">
                <img
                  alt="Telegram"
                  loading="lazy"
                  src="/contact-icons/telegram-200h.webp"
                  className="contactscomponent-image4"
                />
                <div className="contactscomponent-thq-contact-info-elm4">
                  <h3 className="contactscomponent-thq-text-elm5 H1_large">
                    Телеграм
                  </h3>
                  <span className="text_large thq-body-small">
                    @arcobo_robotics
                  </span>
                </div>
              </div>
            </a>
            <a
              href="https://wa.me/77471374713"
              target="_blank"
              rel="noreferrer noopener"
              className="contactscomponent-link5"
            >
              <div className="contactscomponent-thq-content-elm7">
                <img
                  alt="WhatsApp"
                  loading="lazy"
                  src="/contact-icons/whatsapp-200h.webp"
                  className="contactscomponent-image5"
                />
                <div className="contactscomponent-thq-contact-info-elm5">
                  <h3 className="contactscomponent-thq-text-elm6 H1_large">
                    WhatsApp
                  </h3>
                  <span className="text_large">+7 747 13 747 13</span>
                </div>
              </div>
            </a>
            <a
              href="https://www.instagram.com/arcobotech/"
              target="_blank"
              rel="noreferrer noopener"
              className="contactscomponent-link6"
            >
              <div className="contactscomponent-thq-content-elm8">
                <img
                  alt="Instagram"
                  loading="lazy"
                  src="/contact-icons/instagram-200h.webp"
                  className="contactscomponent-image6"
                />
                <div className="contactscomponent-thq-contact-info-elm6">
                  <h3 className="contactscomponent-thq-text-elm7 H1_large">
                    Instagram
                  </h3>
                  <span className="text_large">@arcobotech</span>
                </div>
              </div>
            </a>
            <a
              href="https://www.linkedin.com/company/arcobotech/?viewAsMember=true"
              target="_blank"
              rel="noreferrer noopener"
              className="contactscomponent-link7"
            >
              <div className="contactscomponent-thq-content-elm9">
                <img
                  alt="LinkedIn"
                  loading="lazy"
                  src="/contact-icons/linkedin-200h.webp"
                  className="contactscomponent-image7"
                />
                <div className="contactscomponent-thq-contact-info-elm7">
                  <h3 className="contactscomponent-thq-text-elm8 H1_large">
                    LinkedIn
                  </h3>
                  <span className="text_large">@arcobotech</span>
                </div>
              </div>
            </a>
          </div>
          <img
            alt={props.imageAlt}
            loading="lazy"
            src={props.imageSrc}
            className="contactscomponent-image8 thq-img-ratio-1-1"
          />
        </div>
      </div>
    </div>
  )
}

Contactscomponent.defaultProps = {
  imageAlt: 'image',
  imageSrc:
    'https://images.unsplash.com/photo-1721069662098-f2031c2319b8?ixid=M3w5MTMyMXwwfDF8YWxsfDIyfHx8fHx8Mnx8MTcyMTE0NDMwMHw&ixlib=rb-4.0.3&w=800',
}

Contactscomponent.propTypes = {
  imageAlt: PropTypes.string,
  imageSrc: PropTypes.string,
}

export default Contactscomponent
